import { render, staticRenderFns } from "./ChallengeHeader.vue?vue&type=template&id=1791a181&"
import script from "./ChallengeHeader.vue?vue&type=script&lang=js&"
export * from "./ChallengeHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports